
import './App.css';
import Home from './Pages/Home/Home/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Apartment from './Pages/Home/Apartment/Apartment';
import Blogs from './Pages/Home/Blogs/Blogs';
import Travel from './Pages/Home/Travel/Travel';
import Markting from './Pages/Home/Markting/Markting';

function App() {
  return (
    <div className="">
      <Router>
     
        <Routes>
          <Route exact path="/" element={<Home/>}/>
          <Route exact path="/home" element={<Home/>}/>
          <Route exact path="/apartment" element={<Apartment/>}/>
          <Route exact path="/blogs" element={<Blogs/>}/>
          <Route exact path="/travel" element={<Travel/>}/>
          <Route exact path="/markting" element={<Markting/>}/>
        
        </Routes>
    </Router>
    </div>
  );
}

export default App;
